export const sharedProps = {
  type: "checkbox",
  required: false
};

export const EMAIL_ADDRESS_ERROR_MESSAGE = "Error: Must be a valid email address";
export const ONE_OR_MORE_FAILURES_ERROR_MESSAGE =
  "Error: One or more of the newsletters you selected is not available at the moment.";
export const GENERIC_EMAIL_SIGNUP_SALESFORCE_ERROR_MESSAGE =
  "We are experiencing issues with our subscription system. Please try again or come back soon to complete your sign-up.";

// Future work: Move these ids to Contentful so they can be adjusted as needed.
export const contentPreferences = {
  "newsletters-select-goa": "Mission_GOA",
  "newsletters-select-mbka": "Mission_MBKA",
  "newsletters-select-opc": "Mission_OPC",
  "newsletters-select-general": null, //We purposely don't set this
  "newsletters-select-chicago": "Mission_Chicago_Newsletter"
};

/*
  State is an object with the same keys as the contentPreferences object with true or false
  indicating whether they have been selected.
  Returns: CSV string of content preferences.
*/
export function listContentPreferencesFromState(state) {
  let ids = new Set();
  for (let newsletter in state) {
    if (state[newsletter] && contentPreferences[newsletter]) {
      ids.add(contentPreferences[newsletter]);
    }
  }
  return Array.from(ids).join().toLocaleLowerCase();
}

export const newsletterKeys = {
  "Sign up for all newsletters": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-all`,
      label: "Sign up for all newsletters",
      labelClass: "font-bold",
      id: `newsletters-select-all`
    }
  },
  "The Girls Opportunity Alliance": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-goa`,
      label: "The Girls Opportunity Alliance",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "When girls get the opportunities they deserve, amazing things start to happen. Follow the Girls Opportunity Alliance to help adolescent girls and the grassroots leaders working to educate them.",
      id: `newsletters-select-goa`
    }
  },
  "My Brother's Keeper Alliance": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-mbka`,
      label: "My Brother's Keeper Alliance",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "The MBK Alliance focuses on building safe and supportive communities for boys and young men of color where they feel valued and have clear pathways to opportunity.",
      id: `newsletters-select-mbka`
    }
  },
  "The Obama Presidential Center": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-opc`,
      label: "The Obama Presidential Center",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "Be the first to know about planned exhibits, construction updates, and events related to the Obama Presidential Center, a world-class museum and public gathering space that celebrates our nation’s first African American President and First Lady on the South Side of Chicago.",
      id: `newsletters-select-opc`
    }
  },
  "General News and Updates": {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-general`,
      label: "General News and Updates",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "President and Mrs. Obama believe the most important thing they can do now is pass the torch of leadership on to a new generation. You’ll get updates about our global network of emerging leaders and the inspiring work they’re doing around the world to change their communities -and our world - for the better.",
      id: `newsletters-select-general`
    }
  },
  Chicago: {
    fieldType: "checkboxField",
    fieldProps: {
      ...sharedProps,
      name: `newsletters-select-chicago`,
      label: "Chicago",
      labelClass: "font-bold",
      fieldDetailsRichText:
        "There are many exciting things happening at the Obama Foundation—across the country and the world, but some of the most important work is happening right here in Chicago. We're building a new landmark for the South Side and economic engine for the city with the Obama Presidential Center, in addition to launching new programming, hosting community events, and driving workforce efforts on our beloved South Side.",
      id: `newsletters-select-chicago`
    }
  }
};
